import {EDGE30_ACTION, EVENT_NAMES, SCREEN_NAMES} from '/enum/tealium.enum';
import {getTealiumUtilDefaultInstance} from '/util/tealium';

import {DailyData} from './EdgeDailyTracker';

const keyMap: Record<string, string> = {
  connections: 'connections',
  socialMediaPosts: 'media',
  newFriends: 'friends',
  invitationsToExploreCoaching: 'explore_coaching',
  attendedWeeklyTraining: 'training',
  personalHealthPlan: 'health_plan',
};

const tealium = getTealiumUtilDefaultInstance();

export function trackCounterChange({
  dataKey,
  action,
  button_type,
  value,
  coachId,
  lastPaidRank,
  highestRankDescription,
  coachCurrentRank,
}: {
  dataKey: string;
  action: string;
  button_type: string;
  value: number | boolean;
  coachId: string;
  lastPaidRank: string;
  highestRankDescription: string;
  coachCurrentRank: string;
}) {
  const mappedTask = keyMap[dataKey] || dataKey;
  const sendEvent = tealium.generateTrackEvent({
    eventName: EVENT_NAMES.edge30Task,
  });
  sendEvent({
    task: mappedTask,
    action,
    button_type,
    task_number: `${value}/3`,
    lastPaidRank,
    coachHighestRank: highestRankDescription,
    coachCurrentRank,
    coachID: coachId,
  });
}

export function trackCheckboxToggle_health_plan({
  dataKey,
  value,
  coachId,
  lastPaidRank,
  highestRankDescription,
  coachCurrentRank,
}: {
  dataKey: string;
  value: boolean;
  coachId: string;
  lastPaidRank: string;
  highestRankDescription: string;
  coachCurrentRank: string;
}) {
  const mappedTask = keyMap[dataKey] || dataKey;
  const sendEvent = tealium.generateTrackEvent({
    eventName: EVENT_NAMES.edge30Task,
  });
  sendEvent({
    task: mappedTask,
    action: String(value),
    lastPaidRank,
    coachHighestRank: highestRankDescription,
    coachCurrentRank,
    coachID: coachId,
  });
}

export function trackSaveEvent_edge_30_entry({
  dailyData,
  coachId,
  lastPaidRank,
  highestRankDescription,
  coachCurrentRank,
}: {
  dailyData: DailyData;
  coachId: string;
  lastPaidRank: string;
  highestRankDescription: string;
  coachCurrentRank: string;
}) {
  const isNew = isNewEdgeEntry(dailyData);
  const sendEvent = tealium.generateTrackEvent({
    eventName: EVENT_NAMES.edge30Entry,
  });
  sendEvent({
    screenName: SCREEN_NAMES.edge30,
    entryDate: dailyData.date,
    todaysDate: new Date().toISOString().split('T')[0],
    action: isNew ? EDGE30_ACTION.new : EDGE30_ACTION.edit,
    lastPaidRank,
    coachHighestRank: highestRankDescription,
    coachCurrentRank,
    coachID: coachId,
  });
}

export function isNewEdgeEntry(dailyData: DailyData): boolean {
  return (
    dailyData.socialMediaPosts === 0 &&
    dailyData.invitationsToExploreCoaching === 0 &&
    dailyData.newFriends === 0 &&
    dailyData.connections === 0 &&
    dailyData.attendedWeeklyTraining === 0 &&
    dailyData.personalHealthPlan === false &&
    dailyData.isChallengeCompleted === false
  );
}
